import { proxyAPI } from '../httpClient';

const isDPTAvailable = async (accountId: string) => {
  const response = await proxyAPI.get(
    `gfh/dpt-service/accounts/${accountId}/status`
  );
  return response.data;
};

export default isDPTAvailable;
